/* ==========================================================================
   Novélia — script propio (vanilla JS, sin librerías externas)
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.ed-reveal, .ed-reveal-scale');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ed-visible'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var delay = entry.target.getAttribute('data-ed-delay') || 0;
            setTimeout(function () {
              entry.target.classList.add('ed-visible');
            }, Number(delay));
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );
    els.forEach(function (el) { observer.observe(el); });
  }

  function initCountUp() {
    var els = document.querySelectorAll('[data-ed-countup]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var target = parseFloat(el.getAttribute('data-ed-countup'));
          var suffix = el.getAttribute('data-ed-suffix') || '';
          var duration = 1400;
          var start = null;
          if (reduceMotion) {
            el.textContent = target + suffix;
            observer.unobserve(el);
            return;
          }
          function step(ts) {
            if (!start) start = ts;
            var progress = Math.min((ts - start) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            var value = Math.round(target * eased * 10) / 10;
            el.textContent = value + suffix;
            if (progress < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
          observer.unobserve(el);
        });
      },
      { threshold: 0.4 }
    );
    els.forEach(function (el) { observer.observe(el); });
  }

  function initCountdown() {
    var els = document.querySelectorAll('[data-ed-countdown]');
    els.forEach(function (el) {
      var hours = parseInt(el.getAttribute('data-ed-hours') || '24', 10);
      var storageKey = 'ed-countdown-' + el.id;
      var end = sessionStorage.getItem(storageKey);
      if (!end) {
        end = Date.now() + hours * 3600 * 1000;
        sessionStorage.setItem(storageKey, end);
      } else {
        end = parseInt(end, 10);
      }
      var dEl = el.querySelector('[data-ed-d]');
      var hEl = el.querySelector('[data-ed-h]');
      var mEl = el.querySelector('[data-ed-m]');
      var sEl = el.querySelector('[data-ed-s]');
      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) {
          end = Date.now() + hours * 3600 * 1000;
          sessionStorage.setItem(storageKey, end);
          diff = end - Date.now();
        }
        var d = Math.floor(diff / (86400000));
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (dEl) dEl.textContent = String(d).padStart(2, '0');
        if (hEl) hEl.textContent = String(h).padStart(2, '0');
        if (mEl) mEl.textContent = String(m).padStart(2, '0');
        if (sEl) sEl.textContent = String(s).padStart(2, '0');
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  function initCompare() {
    var wraps = document.querySelectorAll('.ed-compare');
    wraps.forEach(function (wrap) {
      var before = wrap.querySelector('.ed-compare-before');
      var handle = wrap.querySelector('.ed-compare-handle');
      var dragging = false;

      function setPos(clientX) {
        var rect = wrap.getBoundingClientRect();
        var x = Math.min(Math.max(clientX - rect.left, 0), rect.width);
        var pct = (x / rect.width) * 100;
        before.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
        handle.style.left = pct + '%';
      }

      wrap.addEventListener('pointerdown', function (e) {
        dragging = true;
        setPos(e.clientX);
        wrap.setPointerCapture(e.pointerId);
      });
      wrap.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        setPos(e.clientX);
      });
      wrap.addEventListener('pointerup', function () { dragging = false; });
      wrap.addEventListener('pointerleave', function () { dragging = false; });
    });
  }

  function initStickyBar() {
    var bar = document.querySelector('.ed-sticky-bar');
    if (!bar) return;
    var trigger = document.querySelector('[data-ed-sticky-trigger]');
    if (!trigger) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('ed-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      },
      { threshold: 0 }
    );
    observer.observe(trigger);

    var stickyForm = bar.querySelector('[data-ed-sticky-add]');
    var mainForm = trigger.querySelector('form[action*="/cart/add"]');
    if (stickyForm && mainForm) {
      stickyForm.addEventListener('click', function (e) {
        e.preventDefault();
        mainForm.querySelector('[type="submit"]').click();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  }

  function initPopup() {
    var el = document.querySelector('[data-ed-popup]');
    if (!el) return;
    var raw = el.getAttribute('data-ed-popup-items');
    var items = [];
    try { items = JSON.parse(raw); } catch (err) { items = []; }
    if (!items.length) return;
    var nameEl = el.querySelector('[data-ed-popup-name]');
    var textEl = el.querySelector('[data-ed-popup-text]');
    var timeEl = el.querySelector('[data-ed-popup-time]');
    var i = 0;

    function show() {
      var item = items[i % items.length];
      i++;
      nameEl.textContent = item.name;
      textEl.textContent = item.text;
      timeEl.textContent = item.time;
      el.classList.add('ed-visible');
      setTimeout(function () { el.classList.remove('ed-visible'); }, 4600);
    }

    setTimeout(function () {
      show();
      setInterval(show, 8000);
    }, 3000);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initCountUp();
    initCountdown();
    initCompare();
    initStickyBar();
    initPopup();
  });
})();
